import keyMirror from "keymirror";

export default keyMirror({
  INIT_FAVORIS: null,
});
